/**
 * Training enums - SOURCE OF TRUTH
 * Pure TypeScript - no Drizzle imports
 */
// Training category labels
export const trainingCategoryLabels = {
    'getting-started': 'Getting Started',
    'dashboard-guide': 'Dashboard Guide',
    'video-creation': 'Video Creation',
    'lead-management': 'Lead Management',
    sequences: 'Sequences',
    'best-practices': 'Best Practices',
    advanced: 'Advanced',
};
export const trainingCategoryValues = Object.keys(trainingCategoryLabels);
//# sourceMappingURL=training.js.map